import { render, staticRenderFns } from "./ModelBills.vue?vue&type=template&id=0f1604a4&"
import script from "./ModelBills.vue?vue&type=script&lang=js&"
export * from "./ModelBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports